import styled, { css } from 'styled-components';

import { Text } from '../../../../../../components';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { SPACE } from '../../../../../../theme/tokens';
import { DESIGN, DESIGN_GRADIENTS } from '../../design.tokens';

export const Pill = styled.span<{ $small: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  border-radius: 999px;
  border: 1px solid ${DESIGN.newBadgeBorder};
  background: ${DESIGN.newBadgeBg};
  padding: ${SPACE[2]} ${SPACE[8]};
  white-space: nowrap;

  /* The small variant sits over a logo tile, so the translucent wash gets an opaque
     dark base (the logo art must not show through the label). */
  ${({ $small }) =>
    $small &&
    css`
      /* Off the SPACE scale on purpose: the small badge sits over a 56px logo tile and must stay tight. */
      padding: 1px 5px;
      background: ${DESIGN_GRADIENTS.newBadgeSmallFill};
    `}
`;

export const Label = styled(Text)<{ $small: boolean }>`
  margin: 0;
  font-size: ${({ $small }) => ($small ? 9 : 11)}px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.02em;
  color: ${CFG.brandText};
`;
